<template>
  <el-row>
    <el-form ref="formRef" :model="queryParam"
             label-position="right" label-width="60px"
             status-icon>
      <el-form-item label="标题" prop="account">
        <el-input v-model="queryParam.name"
                  @keyup.enter.native = "handleSearch"  style="width: 200px" type="text"/>
      </el-form-item>
    </el-form>
    <el-button :icon="Search" style="margin-left: 20px" type="primary" @click="handleSearch">搜索</el-button>
  </el-row>

  <el-row style="padding: 20px 0 ">
    <el-button :icon="Plus" type="primary" @click="handleAdd">新增</el-button>
  </el-row>
  <el-table :data="tableData" style="width: 100%;padding: 20px">
    <el-table-column label="序号" prop="index"  width="80"/>
    <el-table-column label="标题" prop="title" />

    <el-table-column  label="操作" min-width="120">
      <template #default="scope">
        <el-button link size="small" type="primary" @click="handleClick(scope.row)">
          详情
        </el-button>
        <el-button link size="small" type="primary"  @click="handleEdit(scope.row)">编辑</el-button>
      </template>
    </el-table-column>
  </el-table>
  <div class="pagination">
    <el-pagination :total="total" background layout="prev, pager, next" @current-change="currentChange"/>
  </div>

  <el-dialog v-model="dialogFormVisible" :title="title" width="60%">
    <el-form  ref="ruleFormRef" :model="form" :rules="rules" label-width="100px" style="padding: 20px">
      <el-form-item label="标题" prop="title">
        <el-input v-model="form.title" autocomplete="off"/>
      </el-form-item>
      <el-form-item label="标签" prop="demoTags">
        <el-tag
            v-for="tag in form.demoTags"
            :key="tag"
            style="margin-right: 5px"
            closable
            :disable-transitions="false"
            @close="handleClose(tag)"
        >
          {{ tag }}
        </el-tag>
        <el-input
            v-if="inputVisible"
            ref="InputRef"
            v-model="inputValue"
            size="small"
            style="width: 240px;"
            @keyup.enter="handleInputConfirm"
            @blur="handleInputConfirm"
        />
        <el-button v-else class="button-new-tag" size="small" @click="showInput">
          + New Tag
        </el-button>
      </el-form-item>
      <el-form-item label="视频地址" prop="videoUrl">
        <el-input type="text" v-model="form.videoUrl" autocomplete="off"/>
      </el-form-item>
      <el-form-item label="内容" prop="content">
        <el-input type="textarea" :rows="2" v-model="form.content" autocomplete="off"/>
      </el-form-item>
      <el-form-item label="详情" prop="details">
        <el-input type="textarea" :rows="2"  v-model="form.details" autocomplete="off"/>
      </el-form-item>
      <el-form-item label="图片" prop="titleImage">
      <UploadFile  :fileType="['png','jpg','jpeg']" v-model="form.titleImage"></UploadFile>
<!--        <el-input v-model="form.titleImage" autocomplete="off"/>-->
      </el-form-item>
      <el-form-item label="内容图片">
        <UploadFile :limit="10" :fileType="['png','jpg','jpeg']" v-model="form.contentImage"></UploadFile>
<!--        <el-input v-model="form.contentImage" autocomplete="off"/>-->
      </el-form-item>
      <el-form-item label="过期时间">
        <el-date-picker
            v-model="form.expirationTime"
            type="datetime"
            style="width: 100%;"
            placeholder="请选择过期时间"
            value-format="YYYY-MM-DD hh:mm:ss"
        />
      </el-form-item>
      <el-form-item label="下载链接">
        <div style="width: 100%;">

          <div style="margin-bottom: 10px"  v-if="!disabledText">
            <el-button :icon="Plus" type="primary" @click="handleAddDetails">添加</el-button>
            <el-button :icon="Close" plain type="danger" @click="handleDeleteDetails">删除</el-button>
          </div>
          <el-table ref="tb" :data="form.downloadLinks" border @selection-change="chandleDetailSelectionChange">
            <el-table-column align="center" type="selection" width="50px"/>
            <el-table-column align="center" label="类型"  prop="type" width="auto">
              <template #default="scope">
                <el-select
                    v-model="scope.row.type"
                    placeholder="Select"
                    size="large"
                    :style="{width: '100%'}"
                >
                  <el-option
                      v-for="item in typeoption"
                      :key="item.value"
                      :label="item.name"
                      :value="item.value"
                  />
                </el-select>
              </template>
            </el-table-column>
            <el-table-column align="center" label="地址" prop="url" width="auto">
              <template #default="scope">
                <el-input v-model="scope.row.url" :style="{width: '100%'}" clearable placeholder="地址"></el-input>
              </template>
            </el-table-column>


          </el-table>
        </div>
      </el-form-item>

    </el-form>
    <template #footer v-if="!disabledText">
      <div class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSubmit(ruleFormRef)">
          确定
        </el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script setup>
import {demoInfo, demoList, demoPut,demoUpdate} from '@/apis/home'
import {Search, Plus, Close} from '@element-plus/icons-vue'
import {onMounted, ref,nextTick} from 'vue'
import {ElMessage} from "element-plus";
import  UploadFile from '@/components/UploadFile.vue'

import { ElInput } from 'element-plus'

const inputValue = ref('')
const dynamicTags = ref(['Tag 1', 'Tag 2', 'Tag 3'])
const inputVisible = ref(false)
const InputRef = ref()

const handleClose = (tag) => {
  form.value.demoTags.splice(dynamicTags.value.indexOf(tag), 1)
}

const showInput = () => {
  inputVisible.value = true
  nextTick(() => {
    InputRef.value.input.focus()
  })
}

const handleInputConfirm = () => {
  if (inputValue.value) {
    form.value.demoTags.push(inputValue.value)
  }
  inputVisible.value = false
  inputValue.value = ''
}
const form = ref({
  downloadLinks: [],
  demoTags: [],
  status: 0
})
const title =ref('')
const typeoption = ref([
  {name:'直链',value:'1'},
  {name:'百度云',value:'2'},
  {name:'阿里云',value:'3'},
])
const rules = ref({
  title: [
    {required: true, message: '请输入标题', trigger: 'blur'},
  ],
  content: [
    {required: true, message: '请输入内容', trigger: 'blur'},
  ],
  titleImage: [
    {required: false, message: '请输入图片', trigger: 'blur'},
  ],
})
const dialogFormVisible = ref(false)
const tableData = ref([])
const ruleFormRef = ref()
onMounted(() => {
  getList()
})
const queryParam = ref({
  page: 1,
  limit: 10,
  name: ''
})
const currentChange = (data) => {
  console.log(data)
  queryParam.value.page = data
  getList()
}

const total = ref(0)
const handleSearch = () =>{
  getList()
}
const getList = () => {
  demoList(queryParam.value).then(res => {
    if(res.code===200){
      res.result.records.forEach((i,index)=>{
        var num = index+1>=10?(index+1):'' +(index + 1)
        i.index = index+1>=10? queryParam.value.page * 10 :(queryParam.value.page -1)  + num
      })
      tableData.value = res.result.records
      total.value = res.result.total
    }
  })
}
const handleAdd = () => {
  form.value ={
    downloadLinks: [],
    demoTags: [],
    status: 0
  }
  disabledText.value = false
  title.value = '新增'
  dialogFormVisible.value = true
}
const  disabledText = ref(false)
const handleClick = (row)=>{
  title.value = '详情'
  demoInfo({id:row.id}).then(res=>{
    if(res.code == 200){
      form.value = res.result
    }else{
      ElMessage.error(res.msg);
    }
  })
  disabledText.value = true
  dialogFormVisible.value = true

}

const handleEdit = (row) =>{
  title.value = '编辑'
  demoInfo({id:row.id}).then(res=>{
    if(res.code == 200){
      form.value = res.result
    }else{
      ElMessage.error(res.msg);
    }
  })
  disabledText.value = false
  dialogFormVisible.value = true
}
const handleAddDetails = () => {
  if (form.value.downloadLinks == undefined) {
    form.value.downloadLinks = new Array();
  }
  let obj = {};
  form.value.downloadLinks.push(obj);
}
const handleDeleteDetails = () => {
  if (checkedDetail.value.length == 0) {
    ElMessage.error('请先勾选你要删除的数据项');
  } else {
    const filteredDetails = form.value.downloadLinks.filter(item => !checkedDetail.value.includes(item));
    form.value.downloadLinks = filteredDetails;
  }
}
const tb = ref()
const checkedDetail = ref([])
const chandleDetailSelectionChange = (selection) => {
  if (selection.length > 1) {
    tb.value.clearSelection();
    tb.value.toggleRowSelection(selection.pop());
  } else {
    checkedDetail.value = selection;
  }
}
const handleSubmit = (formEl) => {
  if (!formEl) return
   formEl.validate((valid, fields) => {
    if (valid) {
      if(typeof  form.value.contentImage === 'string'){
        form.value.contentImage = form.value.contentImage ? form.value.contentImage.split(',') : []

      }
      if(form.value.id){
        demoUpdate(form.value).then(res => {

          if (res.code == 200) {
            ElMessage.success(res.msg);
            dialogFormVisible.value = false;
            getList()

          } else {
            ElMessage.error(res.msg);
            dialogFormVisible.value = false;
          }
        })
      }else{
        demoPut(form.value).then(res => {

          if (res.code == 200) {
            ElMessage.success(res.msg);
            dialogFormVisible.value = false;
            getList()

          } else {
            ElMessage.error(res.msg);
            dialogFormVisible.value = false;
          }
        })
      }


    } else {
      console.log('error submit!', fields)
    }
  })

}
</script>
<style scoped>
.pagination{
  padding: 20px;
  width: 100%;
  box-sizing: border-box;
  display: flex;
  justify-content: end;
}
</style>
